import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage
import adminReducer from "../redux/admin_reducer.js";
import staffReducer from "../redux/staff_reducer.js";
import studentReducer from "../redux/student_reducer.js";
import appFormReducer from "../redux/registrationReducer.js";
import admissionReducer from "../redux/admission_reducer.js";
import studentAssesmentReducer from "../redux_computer_base/student_computer_base_reducer.js";
import adminAssesmentReducer from "../redux_computer_base/admin_computer_base_reducer.js";
import staffAssesmentReducer from "../redux_computer_base/staff_computer_base_reducer.js";

// Combine reducers
const rootReducer = combineReducers({
  adminFunction: adminReducer,
  staffFunction: staffReducer,
  studentFunction: studentReducer,
  applictaionForm: appFormReducer,
  admissionActions: admissionReducer,
  // storage for computer base assessment and evaluations
  adminAssesment: adminAssesmentReducer,
  staffAssesment: staffAssesmentReducer,
  studentAssesment: studentAssesmentReducer,
});

// Persist configuration
const persistConfig = {
  key: "root",
  storage,
};

// Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create store with persisted reducer
const store = configureStore({ reducer: persistedReducer });
const persistor = persistStore(store);

export { store, persistor };

// // FUNCTIONS WHITOU REDUX PERSIT *************************************************
// import { combineReducers, configureStore } from "@reduxjs/toolkit";
// // call reducer
// import adminReducer from "./admin_reducer.js";
// import staffReducer from "./staff_reducer";
// import studentReducer from "./student_reducer";
// import appFormReducer from "./registrationReducer.js";
// import admissionReducer from "./admission_reducer.js";

// const rootReducer = combineReducers({
//   adminFunction: adminReducer,
//   staffFunction: staffReducer,
//   studentFunction: studentReducer,
//   applictaionForm: appFormReducer,
//   admissionActions: admissionReducer,
// });

// // create store with reducer
// export default configureStore({ reducer: rootReducer });
